import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from './Shared/services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'InnovativeVision';

  constructor(
    public translate: TranslateService,
    public appservice: AppService,
  ) {

    translate.addLangs(['en', 'mr', 'hi']);
    if (localStorage.getItem('locale')) {
      const browserLang = localStorage.getItem('locale');
      if (browserLang) {
        translate.use(browserLang.match(/en|mr|hi/) ? browserLang : 'mr');
      }
    } else {
      localStorage.setItem('locale', 'mr');
      translate.setDefaultLang('mr');
    }
    //	this.settings = this.appSettings.settings;

    // this.goLive(true);

    if (localStorage.getItem('locale')) {
      const lng = localStorage.getItem('locale');
      if (lng) {
        appservice.setcurrentLanguage(lng);
      }
    }

  }
}
